module.exports = __webpack_public_path__ + "static/media/lilGreen.ce06cc47.jpeg";